// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__j8rGd","inputWrap":"Table_inputWrap__374Po","col":"Table_col__2lc-A","bmiTooltip":"Table_bmiTooltip__11uuA"};